import React from 'react';
import {usePaymentCreditCardContext} from '../../contexts/PaymentCreditCardContex';
import InputCurrency from '../InputCurrency';

const FieldCurrency = () => {
  const {currencyOptions} = usePaymentCreditCardContext();

  return <InputCurrency currencyOptions={currencyOptions}/>
};

export default FieldCurrency;
